import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../data/PaginationModified";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  EyeIcon,
  CallIcon,
} from "../../../images/icons/icons";

const ODMPCListingsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const planStatus = row?.current_plan_status
            ?.replace(/ /g, "_")
            ?.toLowerCase();
          const dateTime = row?.converted_date
            ? row.converted_date.split(" ")
            : null;
          const datePart = dateTime ? dateTime[0] : "";
          const timePart = dateTime ? dateTime[1] + " " + dateTime[2] : "";
          const sourceName =
            row?.source_name.replace(/ /g, "_").toLowerCase() ===
            "wtf_one_day_plan"
              ? "WTF One Day Plan"
              : row?.source_name?.replace(/_/g, " ");

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">
                        {row?.user_name || row?.name || "NA"}
                      </h3>
                      <p className="number">
                        {row?.user_mobile || row?.mobile || "NA"}
                      </p>
                      {row?.user_email || row?.email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || row?.email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">View More</span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px pt20px">
                          <div className="label-value flex-col">
                            <span className="label">gym name</span>
                            <span className="value">
                              {row?.gym_name || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">ODM Status</span>
                            <span className="value">
                              {row?.is_payment_done ? (
                                <CheckCircleIcon />
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Start/Expire Date</span>
                            <span className="value">
                              {row?.start_date
                                ? formatDateTimezon(row.start_date)
                                : "-"}{" "}
                              TO{" "}
                              {row?.expire_date
                                ? formatDateTimezon(row.expire_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">preferred slot</span>
                            <span className="value">
                              {row?.preferred_slot || "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">plan status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  planStatus === "converted"
                                    ? "#379C00"
                                    : planStatus === "expiring"
                                    ? "#EB8317"
                                    : "#D90000",
                                color: "#fff",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              {row?.current_plan_status || "NA"}
                              {row?.subscription_expiry_days && (
                                <small>
                                  ({row.subscription_expiry_days || ""})
                                </small>
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">converted plan</span>
                            <span className="value">
                              {row?.converted_plan_price
                                ? `₹${convertThenFormat(
                                    row.converted_plan_price || 0
                                  )}`
                                : ""}
                              <br />
                              <small>
                                {row?.converted_plan_name?.replace(/_/g, " ") ||
                                  "-"}
                              </small>
                              {datePart && timePart && (
                                <>
                                  <br />
                                  {datePart}
                                  <br />
                                  {timePart}
                                </>
                              )}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">source name</span>
                            <span
                              className={`value ${
                                row?.utm_source ? "link" : ""
                              }`}
                              onClick={() =>
                                row?.utm_source &&
                                setModValues({
                                  isModOpen: true,
                                  modName: "utm_parameters",
                                  rawLeadId: row?.uid,
                                  rowData: row,
                                })
                              }
                            >
                              {sourceName || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">city</span>
                            <span className="value">{row?.city || "NA"}</span>
                          </div>

                          <div className="label-value">
                            <span className="label">gender</span>
                            <span className="value">{row?.gender || "NA"}</span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Added to LMS</span>
                            <span className="value">
                              {row?.added_on_lead
                                ? formatDateTimezon(row.added_on_lead)
                                : "-"}
                              <br />
                              <small className="gray underline">
                                {row?.add_to_lms_time_dif || "-"}
                              </small>
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  modName: row?.added_to_lead
                                    ? "view-lead-journey"
                                    : "add-to-lead",
                                }))
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-plus-square-dotted"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                              </svg>
                            </button>

                            <span className="btn-label">
                              {row?.added_to_lead ? "View Lead" : "Add To LMS"}
                            </span>
                          </div>

                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  modName: "view_details",
                                  rowData: row,
                                  from: "odm",
                                }))
                              }
                            >
                              <EyeIcon />
                            </button>

                            <span className="btn-label">view</span>
                          </div>

                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  modName: "click-to-call",
                                  rowData: row,
                                }))
                              }
                            >
                              <CallIcon color="#000" />
                            </button>

                            <span className="btn-label">call</span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default ODMPCListingsMobile;
